// Importaciones de paquetes
import React, { useEffect, useMemo, useRef, useState } from "react";
import { MRT_ColumnDef } from "material-react-table";
// Importaciones de componentes
import { refresh_token } from "../../main_components/tokens/tokenrefreshNewMethod";
import { UPDATE_NULL_IDENTIFIERS } from "../../main_components/methods_v2/auxiliary_functions_new_method";
import { USER_ROL, RESPONSE } from "./interface/interface";
import MATERIAL_TABLE_CONTAINER from "../../main_components/material_table/table_container";
import GENERAL_FORM from "../../main_components/material_table/general_form";
import {
  updated_form_data,
  validate_data,
  processed_format,
} from "./tools/auxiliar_funtions";
import { create_object } from "./tools/auxiliar_funtions";
//IMG / ICONS

import CREATE from "../../imgComponents/create.png";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveAsIcon from "@mui/icons-material/SaveAs";

import { inf_partner } from "./tools/inf_users";

import { roles_users_get, roles_users_available_get } from "../../services/configuration/rol";

import { user_post, user_put, user_delete } from "../../services/configuration/rol";
import { modules_get } from "../../services/configuration/roles";
import { users_get } from "../../services/configuration/users";

export interface FormData {
  id: number | string;
  username: string;
  fullusername: string;
  phone: string;
  email: string;
  job: string;
}


const USERS: React.FC = () => {
  const [data, setData] = useState<USER_ROL[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [modalT, setmodalT] = useState<boolean>(false);
  const [loadingSkeleton, setLoadingSkeleton] = useState<boolean>(false);
  const [open_form, setopen_form] = useState(false);
  const [isNewEntry, setIsNewEntry] = useState(false);
  const [formData, setformData] = useState([]);
  const [methodDelete, setMethodDelete] = useState(false);
  const [identifier_data, setidentifier_data] = useState<any>(null);

  const update_identifiers = [
    { username: "string" },
    { fullusername: "string" },
    { phone: "string" },
    { email: "string" },
    { paymethod: "string" },
    { job: "string" },
  ];

  const handleAddCustomRoles = async (originalObj: any, isNew: boolean) => {
    try {
      const isTokenValid = await verifyToken();

      if (!isTokenValid) {
        console.error("Token inválido o expirado. Deteniendo el proceso...");
        console.log("Actualizando token...");
        setTimeout(() => {
          handleAddCustomRoles(originalObj, isNew);
        }, 1000);
        return;
      }

      // Ejecutar ambas peticiones al mismo tiempo
      const [userRol, userAvaiableRole] = await Promise.all([
        fetchRolesUsers(originalObj?.id),
        fetchRolesUsersavailable(originalObj?.id)
      ]);

      if (userRol.length === 0) {
        console.error("No se pudo obtener los roles del usuario");
        alert('No se pudo obtener los roles del usuario');
        setLoadingSkeleton(true);
        return;
      }

      delete originalObj.roles;

      originalObj.rol = {
        fetch_roles: userAvaiableRole,
        user_roles: userRol,
        custom_roles: {},
        method: 'UPDATE'
      };

      setformData(originalObj);
      setIsNewEntry(isNew);
      setLoadingSkeleton(false);
      setMethodDelete(false);
    } catch (error) {
      console.error("Error al manejar add_address_bp:", error);
      return null;
    }
  };



  const handleAddUser = async (originalObj: any, isNew: boolean) => {
    try {
      const isTokenValid = await verifyToken();

      if (!isTokenValid) {
        console.error("Token inválido o expirado. Deteniendo el proceso...");
        console.log("Actualizando token...");
        setTimeout(() => {
          handleAddUser(originalObj, isNew);
        }, 1000);
        return;
      }


      const modules = await fetchModules();
      if (modules.length === 0) {
        console.error("No se pudo obtener address o partner");
        setLoadingSkeleton(true)
        return;
      }

      originalObj.rol = { fetch_roles: modules, custom_roles: {}, method: 'CREATE' };

      setformData(originalObj)
      setIsNewEntry(isNew);
      setLoadingSkeleton(false)
      setMethodDelete(false);

    } catch (error) {
      console.error("Error al manejar add_address_bp:", error);
      return null;
    }
  };

  const handleOpenForm = (new_value: any, isNew: boolean) => {
    if (isNew) {
      setLoadingSkeleton(true)
      setopen_form(true);
      setMethodDelete(false);
      handleAddUser(new_value, isNew);
    } else {
      setopen_form(true);
      setLoadingSkeleton(true)
      setMethodDelete(false);
      handleAddCustomRoles(new_value, isNew);
    }
  };



  const handleClose = () => { setopen_form(false); };

  const procesarObjeto = (obj: any) => {
    const { rol, accountnonexpired, accountnonlocked, credentialsnonexpired, editable, failedattempts, id_company_fk, user_enable, id, ...resto } = obj;
    return {
      ...resto,
      roles: { modules: filtrarModulosConSubmodulos(obj.rol?.custom_roles?.modules) ?? [] }
    };
  };


  function filtrarModulosConSubmodulos(modulos: any) {
    return modulos.filter((modulo: any) =>
      Array.isArray(modulo.submodules) && modulo.submodules.length > 0
    );
  }


  const handleSaveData = async (
    finalObject: any,
    method: any,
    identifier_data: any
  ) => {
    console.log("True / Post, False / Put, Delete:", method);

    setmodalT(true);

    try {
      switch (method) {
        case true:
          console.log("Creando objeto...");
          await user_post(procesarObjeto(finalObject));
          console.log("Objeto creado con éxito");
          handleUsers();
          handleClose();
          break;
        case false:
          console.log("Datos a procesar:", procesarObjeto(finalObject));
          await user_put(procesarObjeto(finalObject), identifier_data);
          console.log("Objeto actualizado con éxito");
          handleUsers();
          handleClose();
          break;
        case 'delete':
          console.log("Eliminando objeto...");
          await user_delete(identifier_data);
          console.log("Objeto actualizado con éxito");
          handleUsers();
          handleClose();
          break;

        default:
          console.error("Método no reconocido");
      }
    } catch (error: any) {
      alert(error.response.data.errorMessage.es);
      console.error("Error al procesar los datos:", error);
    } finally {
      setmodalT(false);
      console.log("Operación finalizada.");
    }
  };

  const verifyToken = async (): Promise<boolean> => {
    try {
      return await refresh_token();
    } catch (error) {
      console.error("Error al verificar el token:", error);
      return false;
    }
  };

  const fetchRolesUsers = async (id: any) => {
    try {

      const response = await roles_users_get(id);
      return response.data.roles;
    } catch (error) {
      console.error("Error al obtener los datos de dirección:", error);
      return [];
    }
  };

  const fetchRolesUsersavailable = async (id: any) => {
    try {
      const response = await roles_users_available_get(id);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los datos del socio:", error);
      return [];
    }
  };
  const fetchUsers = async (): Promise<USER_ROL[]> => {
    try {
      const rawResponse = await users_get();
      const data = rawResponse.data;
      console.log(data);
      return UPDATE_NULL_IDENTIFIERS(
        data,
        update_identifiers
      ) as USER_ROL[];
    } catch (error) {
      console.error("Error al obtener los datos del usuario:", error);
      return [];
    }
  };

  const fetchModules = async () => {
    try {
      const response = await modules_get();
      return response.data;
    } catch (error) {
      console.error("Error al obtener el código del socio:", error);
      return [];
    }
  };


  const handleUsers = async (event?: React.SyntheticEvent): Promise<void> => {
    event?.preventDefault();
    setIsLoading(true);
    setmodalT(true);
    setData([]);
    const isTokenValid = await verifyToken();
    if (!isTokenValid) {
      setIsLoading(true);
      setmodalT(true);
      console.error("Token inválido o expirado. Deteniendo el proceso...");
      console.log("Actualizando token...");
      setTimeout(() => {
        handleUsers();
      }, 1000);
      return;
    }
    const data = await fetchUsers();
    setData(data);
    setIsLoading(false);
    setmodalT(false);
  };







  const columns: MRT_ColumnDef<USER_ROL>[] = useMemo(
    () => [
      {
        id: "AC.",
        header: "AC.",
        size: 100,
        enableFilters: false,
        enableColumnFilters: false,
        enableColumnFiltering: false,
        enableEditing: false,
        enableColumnFilterModes: false,
        enableRowOrdering: false,
        enableGrouping: false,
        enableColumnDragging: false,
        enableColumnActions: false,
        accessorFn: (d) => {
          return (
            <div>
              <span
                title="Editar Usuario"
                onClick={() => {
                  console.log(d)
                  setMethodDelete(true);
                  handleOpenForm(d, false);
                  setidentifier_data(d.id);
                }}
              >
                <SaveAsIcon className="icons_general_save"></SaveAsIcon>
              </span>
              <span
                title="Eliminar Usuario"
                onClick={() => {
                  setMethodDelete(true);
                  setopen_form(true);
                  setidentifier_data(d?.id);
                }}
              >
                <DeleteIcon className="icons_general_delete"></DeleteIcon>
              </span>
              {/*  */}
            </div>
          );
        },
        muiTableHeaderCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },

      {
        header: "Usuario",
        id: "username",
        accessorKey: "username",
        size: 250,
        enableEditing: false,
        muiTableBodyCellProps: {
          align: 'justify',
        },
      },
      {
        header: "Nombre",
        id: "fullusername",
        size: 250,
        accessorKey: "fullusername",
      },
      {
        header: "Teléfono",
        id: "phone",
        accessorKey: "phone",
        muiTableBodyCellProps: {
          align: 'center',
        },
      },
      {
        header: "Puesto",
        accessorKey: "job",
        id: "job",
        muiTableBodyCellProps: {
          align: 'justify',
        },
      },
      {
        header: "Correo Eléctronico",
        accessorKey: "email",
        id: "email",
        muiTableBodyCellProps: {
          align: 'justify',
        },
        size: 500,

      },
    ],
    []
  );

  useEffect(() => {
    handleUsers();
  }, []);



  return (
    <div style={{ width: "100%", margin: "0 auto" }} className="new_table_v2">
      <GENERAL_FORM
        open={open_form}
        onClose={handleClose}
        data_form={inf_partner}
        onSave={handleSaveData}
        isNew={isNewEntry}
        title_create="CREAR USUARIO"
        title_update="ACTUALIZAR USUARIO"
        validateField={validate_data}
        handleProcessedFormat={processed_format}
        FormData={FormData}
        original_data={formData}
        size={methodDelete ? "30%" : "75%"}
        methodDelete={methodDelete}
        message_delete="¿Esta seguro de eliminar este usuario?"
        updatedFormData={updated_form_data}
        identifier_data={identifier_data}
        loadingSkeleton={loadingSkeleton}
      />


      <MATERIAL_TABLE_CONTAINER
        columns={columns}
        data={data}
        breadcrumbs={[{ label: "USUARIOS", path: null }]}
        modalT={modalT}
        isLoading={isLoading}
        search_filters={<div></div>
        }
        component_header={
          <img
            style={{ cursor: "pointer" }}
            src={CREATE}
            onClick={() => handleOpenForm(create_object, true)}
          ></img>
        }
        file_name_export="USUARIOS"
        update_identifiers={update_identifiers}
      ></MATERIAL_TABLE_CONTAINER>
    </div>
  );
};

export default USERS;
